import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxButtonModule, DxFormComponent, DxFormModule, DxPopupModule, DxScrollViewModule } from 'devextreme-angular';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpService } from '../../../http.service';
import { DataServiceService } from '../../../services/data-service.service';
import { AllocateCardsToMerchant, TopupMerchantAccount } from '../../home/models';
import notify from 'devextreme/ui/notify';
import { KeycloakService } from 'keycloak-angular';
import { DxSelectBoxTypes } from 'devextreme-angular/ui/select-box';
import { DxButtonTypes } from 'devextreme-angular/ui/button';
import { getSizeQualifier, ScreenService } from '../../../services';
import { UtilityFunctions } from '../../../shared/helpers/utility-functions';
import { catchError, forkJoin, Observable, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  standalone: true,
  imports: [ReactiveFormsModule, DxButtonModule, DxFormModule, CommonModule, DxScrollViewModule, DxPopupModule],
  selector: 'app-allocate-cards-to-merchant',
  templateUrl: './allocate-cards-to-merchant.component.html',
  styleUrl: './allocate-cards-to-merchant.component.scss'
})
export class AllocateCardsToMerchantComponent {
  @Input() colCount: number = 2;
  getSizeQualifier = getSizeQualifier;
  merchantsDataSource: any;
  merchant: any;
  priceListData: any;
  merchantList: any;
  walletList!: any;
  UserKeycloakGuidId: any;
  formValid = false;

  formData = {
    fee: 0,
    amount: 0,
    merchantId: -1,
    walletId: -1,
    numberOfCards: -1,
    unallocatedCards: 0
  };

  numberBoxOptions = {
    showClearButton: true,
    value: this.formData.amount,
    valueChangeEvent: 'input',
    step : 0,
    onValueChanged: (e: any) => {
      this.formData.amount = e.value;
    },
    disabled: this.formData.walletId < 0
  };

  submitButtonOptions: DxButtonTypes.Properties = {
    text: 'Submit',
    type: 'default',
    width: '120px',
    useSubmitBehavior: true,
  };

  WalletDropdownOptions: DxSelectBoxTypes.Properties = {
    items: this.walletList,
    displayExpr: 'name',
    valueExpr: 'id',
    value: this.formData.walletId,
    searchEnabled: true,
    onValueChanged: (e: any) => {
      this.formData.walletId = e.value;
    },
  }
  @ViewChild('allocateCardsToMerchantForm', { static: false }) allocateCardsToMerchantForm!: DxFormComponent;
  @Input() receivedCardStock!: number;

  constructor(private httpService: HttpService, private dataService: DataServiceService, private keycloakService: KeycloakService, public screen: ScreenService, private cdr: ChangeDetectorRef) {

    this.merchantsDataSource = dataService.getQuickActionsMerchantDataSource();

    this.initData()
    this.keycloakService
      .loadUserProfile()
      .then(e => {
        this.UserKeycloakGuidId = e.id!;
      });

  }

  initData() {

    this.formData = {
      fee: 0,
      amount: 0,
      merchantId: -1,
      walletId: -1,
      numberOfCards: 0,
      unallocatedCards: 0
    };

    forkJoin([
      this.httpService
        .getCardsCountByStatus({ status: "unallocated" })
        .subscribe((resp) => {
          this.formData['unallocatedCards'] = resp
        }),
      this.merchantsDataSource.load().then(data => {
        this.merchantList = data;
        this.merchantList = this.merchantList.sort((a, b) => {
          return a.CompanyName.localeCompare(b.CompanyName)
          
        });
      }).catch(error => {
        console.error('Error loading data', error);
      })
    ]);

  }

  ngOnInit() {
  }

  onFormSubmit = (e: SubmitEvent) => {
    var validationResult = this.allocateCardsToMerchantForm.instance.validate();
    if (validationResult.isValid!) {
      let lastCount = this.formData.numberOfCards;
      let data = new AllocateCardsToMerchant(this.formData.merchantId, this.formData.walletId, this.formData.numberOfCards, this.formData.fee, this.UserKeycloakGuidId);

      this.httpService
        .allocateCardsToMerchant(data)
        .pipe(catchError((error: HttpErrorResponse, caught: Observable<any>): Observable<any> => {
          UtilityFunctions.showErrorMessage(error);
          return of();
        }))
        .subscribe(
          response => {
            if (response.success) {
              UtilityFunctions.showMessage(`${lastCount} Cards successfully allocated to the merchant`, "success");

              this.resetFormFields();
              this.httpService
                .getCardsCountByStatus({ status: "unallocated" })
                .subscribe((resp) => {
                  this.formData['unallocatedCards'] = resp
                });

            } else {
              UtilityFunctions.showMessage(`Card allocation failed:\n${response.errors.join('\n')}`, "error")
            }
          });
      e.preventDefault();
    } else {
      UtilityFunctions.showMessage("Form is invalid", "error");
    }


  };

  onFieldChange(fieldName?, value?, event?: any) {
    var validationResult = this.allocateCardsToMerchantForm.instance.validate();
    this.formValid = validationResult.isValid ? validationResult.isValid : false;

    if (event?.dataField == "merchantId") {
      this.httpService.getCardPricelistByMerchant(event.value)
        .subscribe(res => {
          this.priceListData = res;
          this.formData['fee'] = this.priceListData ? this.priceListData.rate : 0;

          this.httpService.getWalletsByMerchant(event.value).subscribe(res => {
            this.walletList = res;
          });

          this.formData['walletId'] = 0
          this.allocateCardsToMerchantForm.instance.getEditor('numberOfCards')?.reset();

          this.cdr.detectChanges();

      });
    }

    if (event?.dataField == "walletId") {
      this.allocateCardsToMerchantForm.instance.getEditor('numberOfCards')?.reset();
    }

  }


  resetFormFields() {
    this.allocateCardsToMerchantForm.instance.reset()
    this.initData();
  }

  handleCardStockUpdate(data: number) {
    this.httpService
      .getCardsCountByStatus({ status: "unallocated" })
      .subscribe((resp) => {
        this.formData['unallocatedCards'] = resp
      });
  }

}
